exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "map-editor .table.no-border-top {\n  border-top: 2px solid var(--color-white);\n}\nmap-editor .table.no-border-top .table-label {\n  padding: .8rem 0 0 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/forms/mapEditor/mapEditor.component.less
// module id = 3276
// module chunks = 0